import React, { useEffect, useState } from "react"
import { Link, useNavigate, useParams } from "react-router-dom"
import Dropzone from "react-dropzone"
import Swal from 'sweetalert2'; // Add this import at the top

import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

// FlatPickr
import "flatpickr/dist/themes/material_blue.css"
import FlatPickr from "react-flatpickr"

import * as Yup from "yup"
import { useFormik } from "formik"
import moment from "moment"
import { dropRight } from "lodash"
import {
  addNewProjectRFQ,
  getAllHeadList,
  getAllProjectsForRfq,
  getAllSubHeadList,
  getRfqDetail,
  updateNewProjectRFQ,
} from "helpers/fakebackend_helper"

const EditProjectRFQ = () => {
  //meta title
  document.title = "Edit RFQ "
  const navigate = useNavigate()
  const [selectedFiles, setselectedFiles] = useState([])
  const {id} = useParams()
  const [tasks, setTasks] = useState([{ task: "", document_required: null }])



  const [rfqDetails, setRfqDetails] = useState({})

  useEffect(() => {
    const fetchRfqDetails = async () => {
      const rfqResponse = await getRfqDetail(id)
      if (rfqResponse) {
        setRfqDetails(rfqResponse.data)
        setTasks(rfqDetails.tasks)
      }
      
    }
    fetchRfqDetails()
  }, [id])
  
  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      project_id: rfqDetails.project_id,
      rfq_title: rfqDetails.rfq_title,
      good_service_head_id: rfqDetails.good_service_head_id,
      good_service_subhead_id: rfqDetails.good_service_subhead_id,
      budget: rfqDetails.budget,
      issue_date: rfqDetails.created_at,
      valid_from: rfqDetails.edit_valid_from,
      valid_to: rfqDetails.edit_valid_to,
      security_deposit_amount: rfqDetails.security_deposit_amount,
      tasks: rfqDetails?.tasks || [{ task: "", document_required: "" }],
      requirement_specification: rfqDetails.requirement_specification,
      tender_document: "",
      work_timeline: rfqDetails.work_timeline || ""
    },
    
    validationSchema: Yup.object({
      project_id: Yup.string().required("Please Select Your Project"),
      good_service_head_id: Yup.string().required("Please Select Head"),
      good_service_subhead_id: Yup.string().required("Please Select SubHead"),
      budget: Yup.string().required("Please Enter Your Budget"),
    }),
    onSubmit: async (values, { resetForm }) => {
      try {
        const response = await updateNewProjectRFQ(id, values);

        if (response.status === true) {
          Swal.fire({
            icon: 'success',
            title: 'Success!',
            text: response.message || 'RFQ created successfully',
            confirmButtonColor: '#3085d6',
          }).then((result) => {
            if (result.isConfirmed) {
              // Redirect to RFQ list page
              navigate('/project-management/rfq-list');
            }
          });
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Error!',
            text: response.message || 'Failed to create RFQ',
          });
        }
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Error!',
          text: error?.response?.data?.message || 'An unexpected error occurred',
        });
      } finally {
        // Reset form and clear files
        resetForm();
        toggle(); // Assuming this is a modal close function
        setselectedFiles([]);
      }
    }
  });
  console.log("tasks",tasks)
  const [projects, setProjectList] = useState([])
  useEffect(() => {
    // Define and execute data fetching functions
    const fetchProjectData = async () => {
      try {
        const response = await getAllProjectsForRfq()
        setProjectList(response.project)
      } catch (error) {
        console.error("Error fetching users:", error)
      }
    }

    // Call both fetch functions
    fetchProjectData()
  }, [])
  const [headList, setHeadList] = useState([])
  useEffect(() => {
    // Define and execute data fetching functions
    const fetchHeadData = async () => {
      try {
        const response = await getAllHeadList()
        setHeadList(response.data)
      } catch (error) {
        console.error("Error fetching subhead:", error)
      }
    }

    // Call both fetch functions
    fetchHeadData()
  }, [])
  const [subHeadList, setSubHeadList] = useState([])
  useEffect(() => {
    // Define and execute data fetching functions
    const fetchSubHeadData = async () => {
      try {
        const response = await getAllSubHeadList(
          validation.values.good_service_head_id
        )
        setSubHeadList(response.GoodServiceSubHead)
      } catch (error) {
        console.error("Error fetching subhead:", error)
      }
    }

    // Call both fetch functions
    if (validation.values.good_service_head_id){

      fetchSubHeadData()
    }
  }, [validation.values.good_service_head_id])

    const handleAddTask = () => {
    const newTasks = [...validation.values.tasks, { task: "", document_required: "" }]
    validation.setFieldValue("tasks", newTasks)
  }

  const handleDeleteTask = (index) => {
    const newTasks = validation.values.tasks.filter((_, i) => i !== index)
    validation.setFieldValue("tasks", newTasks)
  }

  console.log("validation.values.tasks", validation.values.tasks)
  if (!rfqDetails) {
    return <div>Loading...</div>
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          
              
              <Breadcrumbs title="Edit RFQ" 
              //breadcrumbItem="Edit RFQ" 
              />
              <Row className="justify-content-center">
                <Col lg={12}>
                  <CardTitle className="h4 mb-3" style={{ fontSize: "20px" }}>
                    <div className="d-flex gap-2 ">
                      <i
                        className="mdi mdi-arrow-left font-size-20"
                        style={{ color: "grey" }}
                        onClick={() => {
                          navigate(-1)
                        }}
                      ></i>
                      Edit RFQ
                    </div>
                  </CardTitle>
                </Col>
              </Row>
          <Row>
            <Col lg="12">
              <Form
                autoComplete="off"
                onSubmit={e => {
                  e.preventDefault()
                  validation.handleSubmit()
                  return false
                }}
              >
                <Card>
                  <CardBody>
                    <Row>
                      <Col xs="12" md="6">
                        <div className="mb-3">
                          <Label htmlFor="project" className="fw-medium">
                            Project
                          </Label>
                          <Input
                            type="select"
                            id="project_id"
                            name="project_id"
                            className="form-control"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.project_id || ""}
                            invalid={
                              validation.touched.project_id &&
                              validation.errors.project_id
                                ? true
                                : false
                            }
                          >
                            <option value="">Select Project</option>
                            {projects.map((project, index) => (
                              <option key={index} value={project.id}>
                                {project.project_name}
                              </option>
                            ))}
                          </Input>
                          {validation.touched.project_id &&
                          validation.errors.project_id ? (
                            <FormFeedback type="invalid">
                              {validation.errors.project_id}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                      <Col xs="12" md="6">
                        <div className="mb-3">
                          <Label htmlFor="rfq_title" className="fw-medium">
                            RFQ Title
                          </Label>
                          <Input
                            type="text"
                            id="rfq_title"
                            name="rfq_title"
                            className="form-control"
                            placeholder="Enter RFQ Title"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.rfq_title || ""}
                            invalid={
                              validation.touched.rfq_title &&
                              validation.errors.rfq_title
                                ? true
                                : false
                            }
                          />
                          {validation.touched.rfq_title &&
                          validation.errors.rfq_title ? (
                            <FormFeedback type="invalid">
                              {validation.errors.rfq_title}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                      <Col xs="12" md="6">
                        <div className="mb-3">
                          <Label
                            htmlFor="good_service_head_id"
                            className="fw-medium"
                          >
                            Goods/Services Head
                          </Label>
                          <Input
                            type="select"
                            id="good_service_head_id"
                            name="good_service_head_id"
                            className="form-control"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.good_service_head_id || ""}
                            invalid={
                              validation.touched.good_service_head_id &&
                              validation.errors.good_service_head_id
                                ? true
                                : false
                            }
                          >
                            <option value="">Select Head</option>
                            {headList.map((head, index) => (
                              <option key={index} value={head.id}>
                                {head.head_text} ({head.good_and_service_category})
                              </option>
                            ))}
                          </Input>
                          {validation.touched.good_service_head_id &&
                          validation.errors.good_service_head_id ? (
                            <FormFeedback type="invalid">
                              {validation.errors.good_service_head_id}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                      <Col xs="12" md="6">
                        <div className="mb-3">
                          <Label
                            htmlFor="good_service_subhead_id"
                            className="fw-medium"
                          >
                            Goods/Services Sub-Head
                          </Label>
                          <Input
                            type="select"
                            id="good_service_subhead_id"
                            name="good_service_subhead_id"
                            className="form-control"
                            placeholder="Enter Subhead"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={
                              validation.values.good_service_subhead_id || ""
                            }
                            invalid={
                              validation.touched.good_service_subhead_id &&
                              validation.errors.good_service_subhead_id
                                ? true
                                : false
                            }
                          >
                            <option value="">Select Sub-Head</option>
                            {subHeadList.map((Subhead, index) => (
                              <option key={index} value={Subhead.id}>
                                {Subhead.subhead_text} ({Subhead.head_text})
                              </option>
                            ))}
                          </Input>
                          {validation.touched.good_service_subhead_id &&
                          validation.errors.good_service_subhead_id ? (
                            <FormFeedback type="invalid">
                              {validation.errors.good_service_subhead_id}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                      <Col xs="12" md="6">
                        <div className="mb-3">
                          <Label htmlFor="budget" className="fw-medium">
                            Budget (Rs)
                          </Label>
                          <Input
                            id="budget"
                            name="budget"
                            type="text"
                            placeholder="Enter Project Budget..."
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.budget || ""}
                            invalid={
                              validation.touched.budget &&
                              validation.errors.budget
                                ? true
                                : false
                            }
                          />
                          {validation.touched.budget &&
                          validation.errors.budget ? (
                            <FormFeedback type="invalid">
                              {validation.errors.budget}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                      {/* <Col xs="12" md="6">
                        <div className="mb-3">
                          <Label htmlFor="issue_date" className="fw-medium">
                            Issue Date
                          </Label>
                          <Input
                            id="issue_date"
                            name="issue_date"
                            type="date"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.issue_date || ""}
                            invalid={
                              validation.touched.issue_date &&
                              validation.errors.issue_date
                                ? true
                                : false
                            }
                          />
                          {validation.touched.issue_date &&
                          validation.errors.issue_date ? (
                            <FormFeedback type="invalid">
                              {validation.errors.issue_date}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col> 
                      <Col xs="12" md="6">
                        <div className="mb-3">
                          <Label htmlFor="valid_from" className="fw-medium">
                            Valid From
                          </Label>
                          <Input
                            id="valid_from"
                            name="valid_from"
                            type="date"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.valid_from || ""}
                            invalid={
                              validation.touched.valid_from &&
                              validation.errors.valid_from
                                ? true
                                : false
                            }
                          />
                          {validation.touched.valid_from &&
                          validation.errors.valid_from ? (
                            <FormFeedback type="invalid">
                              {validation.errors.valid_from}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>*/}
                      <Col xs="12" md="6">
                        <div className="mb-3">
                          <Label htmlFor="valid_to" className="fw-medium">
                            Expiry Date*
                          </Label>
                          <Input
                            id="valid_to"
                            name="valid_to"
                            type="date"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.valid_to || ""}
                            invalid={
                              validation.touched.valid_to &&
                              validation.errors.valid_to
                                ? true
                                : false
                            }
                          />
                          {validation.touched.valid_to &&
                          validation.errors.valid_to ? (
                            <FormFeedback type="invalid">
                              {validation.errors.valid_to}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                      <Col xs="12" md="6">
                        <div className="mb-3">
                          <Label htmlFor="security_deposit_amount" className="fw-medium">
                            Security Deposit (Percentage of Total Final Amount)*
                          </Label>
                          <Input
                            id="security_deposit_amount"
                            name="security_deposit_amount"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.security_deposit_amount || ""}
                            invalid={
                              validation.touched.security_deposit_amount &&
                              validation.errors.security_deposit_amount
                                ? true
                                : false
                            }
                          />
                          {validation.touched.security_deposit_amount &&
                          validation.errors.security_deposit_amount ? (
                            <FormFeedback type="invalid">
                              {validation.errors.security_deposit_amount}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                      <Col xs="12" md="6">
                        <div className="mb-3">
                          <Label htmlFor="work_timeline" className="fw-medium">
                            Work Timeline*
                          </Label>
                          <Input
                            id="work_timeline"
                            name="work_timeline"
                            type="date"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.work_timeline || ""}
                            invalid={
                              validation.touched.work_timeline &&
                              validation.errors.work_timeline
                                ? true
                                : false
                            }
                          />
                          {validation.touched.work_timeline &&
                          validation.errors.work_timeline ? (
                            <FormFeedback type="invalid">
                              {validation.errors.work_timeline}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
                {/* Dynamic Task Checklist Rows */}

                <Card>
                  <CardBody>
                    <Row className="mb-3">
                      <Col md={5}><Label>Task Checklist</Label></Col>
                      <Col md={5}><Label>Documents Required</Label></Col>
                    </Row>
                    
                    {validation.values.tasks.map((task, index) => (
                      <Row key={index} className="align-items-center mb-3">
                        <Col md={5}>
                          <Input
                            name={`tasks[${index}].task`}
                            value={task.task}
                            onChange={validation.handleChange}
                            placeholder="Enter task"
                          />
                        </Col>
                        <Col md={5}>
                          <Input
                            name={`tasks[${index}].document_required`}
                            value={task.document_required}
                            onChange={validation.handleChange}
                            placeholder="Enter document details"
                          />
                        </Col>
                        <Col md={2}>
                          <Button
                            color="danger"
                            disabled={validation.values.tasks.length === 1}
                            onClick={() => handleDeleteTask(index)}
                          >
                            Delete
                          </Button>
                        </Col>
                      </Row>
                    ))}
                    
                    <Button color="primary" onClick={handleAddTask}>
                      Add Task
                    </Button>
                  </CardBody>
                </Card>

                <Row className="mb-4">
                  <Col lg="12">
                    <Label className="col-form-label col-lg-2 fw-medium">
                      Tender Document
                      
                    </Label>
                    <a target="_blank" rel="noreferrer" href={rfqDetails.tender_document_viewPath}>[View Tender Document]</a>
                    <Input
                      id="tender_document"
                      name="tender_document"
                      type="file"
                      className="form-control"
                      onChange={e => {
                        validation.setFieldValue(
                          "tender_document",
                          e.currentTarget.files[0]
                        )
                      }}
                      onBlur={validation.handleBlur}
                      invalid={
                        validation.touched.tender_document &&
                        validation.errors.tender_document
                      }
                    />

                    {validation.touched.tender_document &&
                    validation.errors.tender_document ? (
                      <FormFeedback type="invalid">
                        {validation.errors.tender_document}
                      </FormFeedback>
                    ) : null}

                    {validation.values.tender_document && (
                      <div className="mt-2">
                        <small className="text-muted">
                          Selected file:{" "}
                          {validation.values.tender_document.name}
                        </small>
                      </div>
                    )}
                  </Col>
                </Row>
                <Row>
                  <FormGroup className="mb-4" row>
                    <Col lg="12">
                      <label
                        htmlFor="requirement_specification"
                        className="col-form-label col-lg-2 fw-medium"
                        style={{ whiteSpace: "pre-line" }}
                      >
                        Requirement Specification
                      </label>
                      <Input
                        id="request-textarea"
                        name="requirement_specification"
                        type="textarea"
                        rows="5"
                        placeholder="Enter Requirement Specification..."
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={
                          validation.values.requirement_specification || ""
                        }
                        invalid={
                          validation.touched.requirement_specification &&
                          validation.errors.requirement_specification
                            ? true
                            : false
                        }
                      />
                      {validation.touched.projectbudget &&
                      validation.errors.projectbudget ? (
                        <FormFeedback type="invalid">
                          {validation.errors.requirement_specification}
                        </FormFeedback>
                      ) : null}
                    </Col>
                  </FormGroup>
                </Row>
                <Row className="mb-4">
                  <Col lg="12" className="d-flex justify-content-end">
                    <Button
                      type="submit"
                      color="primary"
                      style={{ marginRight: "12px" }}
                    >
                      Save
                    </Button>
                    <Button type="button" color="danger" onClick={()=>{navigate(-1)}}>
                      Cancel
                    </Button>
                  </Col>
                </Row>
              </Form>
              {/* <Row className="justify-content-end"> */}
              {/* </Row> */}
            </Col>
          </Row>

          {/* <Row>
            <Col lg="4">
              <Card>
                <CardBody>
                  <CardTitle className="mb-4">RFQ Details</CardTitle>
                  <Row>
                    <span className="fw-bold">Project:</span>
                    <span className="mb-3"> Project2</span>
                  </Row>
                  <Row>
                    <span className="fw-bold">Goods/Services Head:</span>
                    <span className="mb-3"> Head2</span>
                  </Row>
                  <Row>
                    <span className="fw-bold">Goods/Services Subhead:</span>
                    <span className="mb-3"> Subhead2</span>
                  </Row>
                  <Row>
                    <span className="fw-bold">Budget:</span>
                    <span className="mb-3"> XXXX</span>
                  </Row>
                  <Row>
                    <span className="fw-bold">Requirement Specification:</span>
                    <span className="mb-3">
                      {" "}
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                      sed do eiusmod tempor incididunt ut
                    </span>
                  </Row>
                  <Row>
                    <span className="fw-bold">Tender Document:</span>
                    <div className="dropzone-previews" id="file-previews">
                      {selectedFiles.map((f, i) => {
                        return (
                          <Card
                            className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete d-inline"
                            key={i + "-file"}
                          >
                            <div className="p-2">
                              <Row className="align-items-center">
                                <Col>
                                  <img
                                    data-dz-thumbnail=""
                                    height="80"
                                    className="avatar-sm rounded bg-light"
                                    alt={f.name}
                                    src={f.preview}
                                  />
                                </Col>
                              </Row>
                            </div>
                          </Card>
                        )
                      })}
                    </div>
                  </Row>
                </CardBody>
              </Card>
            </Col>
            <Col>
              <Card>
                <CardBody></CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col lg="4">
              <Card>
                <CardBody>
                  <CardTitle className="mb-4">RFQ Details</CardTitle>
                  <Row>
                    <Col className="mb-4">
                      <span className="fw-bold">Project:</span>
                      <span className="mb-3"> Project2</span>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="mb-4">
                      <span className="fw-bold">Goods/Services Head:</span>
                      <span className="mb-3"> Head2</span>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="mb-4">
                      <span className="fw-bold">Goods/Services Subhead:</span>
                      <span className="mb-3"> Subhead2</span>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="mb-4">
                      <span className="fw-bold">Budget:</span>
                      <span className="mb-3"> XXXX</span>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="mb-4">
                      <span className="fw-bold">
                        Requirement Specification:
                      </span>
                      <span className="mb-3">
                        {" "}
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                        sed do eiusmod tempor incididunt ut
                      </span>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="mb-4">
                      <span className="fw-bold">Tender Document:</span>
                      <div className="dropzone-previews" id="file-previews">
                        {selectedFiles.map((f, i) => {
                          return (
                            <Card
                              className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                              key={i + "-file"}
                            >
                              <div className="p-2">
                                <Row className="align-items-center">
                                  <Col className="col-auto">
                                    <img
                                      data-dz-thumbnail=""
                                      height="80"
                                      className="avatar-sm rounded bg-light"
                                      alt={f.name}
                                      src={f.preview}
                                    />
                                  </Col>
                                  <Col>
                                    <Link
                                      to="#"
                                      className="text-muted font-weight-bold"
                                    >
                                      {f.name}
                                    </Link>
                                    <p className="mb-0">
                                      <strong>{f.formattedSize}</strong>
                                    </p>
                                  </Col>
                                </Row>
                              </div>
                            </Card>
                          )
                        })}
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row> */}
        </Container>
      </div>
    </React.Fragment>
  )
}

export default EditProjectRFQ
